import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestModel } from '../models';
import {AppConfig} from '../_config'
@Injectable({
  providedIn: 'root'
})
export class BaseService {
  private baseAddress: string = '';
  private accessKey: string;
  constructor(appConfig:AppConfig, private _http: HttpClient) { 
    this.baseAddress = appConfig.backendUrl;
    this.accessKey = appConfig.accessKey;
  }

  Request(request: RequestModel, requestParameters = null) {
    let requestOptions = { headers: null, body: null, params: null };
    let getAppendedURL = '';
    if(requestParameters!= null){
      if(request.method.toLowerCase() =='get'){
        {
          for(let i=0;i<requestParameters.length;i++){
            getAppendedURL = requestParameters[i].key;
            request.url = request.url + '/' + getAppendedURL;
          }
          
        }
      } else{
        requestOptions.body = requestParameters;
      }
    }

    return this._http.request<any>(request.method, this.baseAddress + request.url, requestOptions);
  }

  GetIPData(){
    let request = {address:"http://api.ipapi.com/api/check?access_key="+this.accessKey};
    return this._http.get<any>(request.address);
  }
  
}
